<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="保证金主表ID">
                <a-input v-model="queryParam.bondId" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="流水号">
                <a-input v-model="queryParam.flowNo" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="流水类型">
                <a-input v-model="queryParam.flowType" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-input v-model="queryParam.bizType" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:masterBondFlow:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:masterBondFlow:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operateTime" slot-scope="text, record">
          {{ parseTime(record.operateTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['order:masterBondFlow:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['order:masterBondFlow:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:masterBondFlow:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delOrderMasterBondFlow, pageOrderMasterBondFlow } from '@/api/order/masterBondFlow'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderMasterBondFlow',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      total: 0,
      single: true,
      multiple: true,
      ids: [],
      queryParam: {
        bondId: undefined,
        bondItemId: undefined,
        masterOrderId: undefined,
        flowNo: undefined,
        flowType: undefined,
        bizType: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: 'id', dataIndex: 'id', ellipsis: true, align: 'center', width: 100 },
        { title: 'bondId', dataIndex: 'bondId', align: 'center', width: 100 },
        { title: '流水号', dataIndex: 'flowNo', ellipsis: true, align: 'center', width: 160 },
        { title: '流水类型', dataIndex: 'flowType', align: 'center', width: 90 },
        { title: '业务类型', dataIndex: 'bizType', align: 'center', width: 90 },
        { title: '变动金额', dataIndex: 'changeAmount', align: 'center', width: 100 },
        { title: '操作时间', dataIndex: 'operateTime', scopedSlots: { customRender: 'operateTime' }, align: 'center', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', width: 140, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const q = { ...this.queryParam }
      ;['bondId', 'bondItemId', 'masterOrderId', 'flowType', 'bizType'].forEach(k => {
        if (q[k] === '' || q[k] === undefined) {
          delete q[k]
        } else {
          q[k] = Number(q[k])
          if (Number.isNaN(q[k])) delete q[k]
        }
      })
      if (!q.flowNo) {
        delete q.flowNo
      }
      pageOrderMasterBondFlow(q).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        bondId: undefined,
        bondItemId: undefined,
        masterOrderId: undefined,
        flowNo: undefined,
        flowType: undefined,
        bizType: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      const that = this
      const ids = row.id != null ? [row.id] : this.ids
      if (row.id != null) {
        this.ids = [row.id]
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delOrderMasterBondFlow(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          that.ids = that.selectedRows.map(item => item.id)
        }
      })
    }
  }
}
</script>
